import React from "react";

function footer(){
    return(
        <div className="mt-10 mb-5 text-center text-pink-700">
            <h4>~Designed by Mohith for desktop browsers using React and Tailwind~</h4>
        </div>
    );
};

export default footer;